

import React from 'react';
 
import App from './App';
import { BrowserRouter } from "react-router-dom";
import "./index.css"
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from 'contexts/AuthContext';
import { AppProvider } from 'contexts/AppContext';
import { AuthAdminProvider } from 'contexts/AuthAdminContext';
import "bootstrap/dist/css/bootstrap.min.css" 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>  
        <AppProvider>
           <AuthAdminProvider>
            <App />
           </AuthAdminProvider> 
        </AppProvider>
      </AuthProvider>
    </BrowserRouter>
   
  </React.StrictMode>
);
reportWebVitals();

 